import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { AuthProvider } from './contexts/AuthContext';

const container = document.getElementById("root")!;

const tree = (
  <AuthProvider>
    <App />
  </AuthProvider>
);

// Prerendered pages ship static HTML in #root: hydrate instead of re-rendering.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
